"use strict";
/**
 * QVET Pets (Mascotas) Contracts
 * Report: listadoMascotas
 */
Object.defineProperty(exports, "__esModule", { value: true });
